import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Doijiko = _resolveComponent("Doijiko")
  const _component_ChangeLog = _resolveComponent("ChangeLog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("span", { innerHTML: _ctx.content1 }, null, 8, ["innerHTML"]),
    _hoisted_1,
    _createVNode(_component_Doijiko),
    _createVNode("span", { innerHTML: _ctx.content2 }, null, 8, ["innerHTML"]),
    _createVNode(_component_ChangeLog)
  ], 64))
}